import React, {PureComponent} from 'react';
import {connect} from 'react-redux';

class MainWrapper extends PureComponent {
  render() {
    return (
      <div className="theme-light">
        <div className="wrapper blocks-with-shadow-theme top-navigation">
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default connect()(MainWrapper);



// WEBPACK FOOTER //
// ./src/app/MainWrapper.js